import { ChangeDetectorRef, Component, inject, Input, type OnDestroy, type OnInit, Output } from '@angular/core';
import { Subject } from 'rxjs';
import { BsModalRef } from 'ngx-bootstrap/modal';
import type { DeviceMode } from '@common/types/layout.type';
import { SpCommonEditorComponent } from '../../../sp-common-editor/src/sp-editor-common.component';
import { NgClass, NgIf } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

export type SubscriptionMessageModalPayload = { cachedText: string };

@Component({
    selector: 'sp-subscription-message-modal',
    templateUrl: './subscription-message-modal.component.html',
    styles: [
        `
            :host ::ng-deep {
                .tox.tox-tinymce {
                    min-width: 100%;
                    max-width: 536px;
                }
            }
        `,
    ],
    imports: [SpCommonEditorComponent, NgIf, NgClass, TranslateModule],
})
export class SubscriptionMessageModalComponent implements OnInit, OnDestroy {
    private bsModalRef = inject(BsModalRef);
    private readonly changeDetectorRef = inject(ChangeDetectorRef);

    @Input() public baseHref: string;
    @Input() public deviceMode: DeviceMode;
    @Input() public isShopCart: boolean;

    @Output() public saveData: Subject<SubscriptionMessageModalPayload> = new Subject();

    public subscriptionMessage: string;
    public cachedText: string;
    public isSaved = false;

    public isBlockConfirm: boolean = false;

    public ngOnInit(): void {
        this.cachedText = this.subscriptionMessage;

        this.changeDetectorRef.detectChanges();
    }

    public ngOnDestroy(): void {
        if (!this.isSaved) {
            this.saveData.next({ cachedText: this.cachedText });
            this.bsModalRef.hide();
        }
    }

    public onConfirm(): void {
        this.isSaved = true;
        this.saveData.next({ cachedText: this.subscriptionMessage });
        this.bsModalRef.hide();
    }

    public onCancel(): void {
        this.isSaved = false;
        this.saveData.next({ cachedText: this.cachedText });
        this.bsModalRef.hide();
    }

    public blurHandler(content: string): void {
        this.subscriptionMessage = content;
    }

    public isEmptyContent(value: boolean): void {
        this.isBlockConfirm = value;
        this.changeDetectorRef.detectChanges();
    }

    public get titleText(): string {
        return this.isShopCart ? 'shop_cart_payment_success_message_label' : 'subscription_message';
    }
}
